var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.33073H16V8.66406H21.3333V24.6641H2.66667V3.33073ZM1.33133 0.664062C0.596653 0.664062 0 1.25613 0 1.98646V26.0083C0 26.7237 0.593013 27.3307 1.32453 27.3307H22.6755C23.4068 27.3307 24 26.7293 24 25.9874L23.9996 7.33073L17.3333 0.664062H1.33133ZM9.99987 7.9974C9.99987 10.1007 9.39227 12.5805 8.36657 14.8686C7.33716 17.165 5.94857 19.131 4.50032 20.2895L6.07285 22.4402C9.97613 19.8379 14.2977 18.0535 18.478 18.6507L19.0883 16.0658C15.5247 14.8779 12.6665 11.3173 12.6665 7.9974H9.99987ZM10.7999 15.9595C11.1564 15.1643 11.4723 14.3391 11.7383 13.5021C12.3671 14.4682 13.1404 15.355 14.0135 16.1245C12.7044 16.3589 11.422 16.7435 10.1803 17.2342C10.3999 16.8165 10.6068 16.3905 10.7999 15.9595Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploaded);
export default __webpack_public_path__ + "static/media/file-uploaded.b52b0723f680b2e281c023d0d43baa27.svg";
export { ForwardRef as ReactComponent };